import { render, staticRenderFns } from "./CertificateProduct.vue?vue&type=template&id=661fda58&scoped=true"
import script from "./CertificateProduct.vue?vue&type=script&lang=js"
export * from "./CertificateProduct.vue?vue&type=script&lang=js"
import style0 from "./CertificateProduct.scss?vue&type=style&index=0&id=661fda58&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661fda58",
  null
  
)

export default component.exports